<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="parentFolderName">
                        Tworzenie podfolderu w folderze <strong>{{ parentFolderName }}</strong> 
                    </template>
                    <template v-else>
                        Tworzenie folderu głównego
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-text-field
                    v-model="processSubjectData.name"
                    label="Nazwa"
                    required
                    solo
                    :error-messages="processSubjectErrors"
                    @input="$v.newProcessSubject.name.$touch()"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveProcessSubject"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddProcessSubjectDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        newProcessSubject: {
            type: Object,
            default: () => ({})
        },
        parentFolderId: {
            type: Number,
            default: null
        },
        parentFolderName: {
            type: String,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    validations() {
        return {
            newProcessSubject: {
                name: {
                    required
                }
            }
        }
    },
    computed: {
        processSubjectErrors() {
            const errors = []

            if (!this.$v.newProcessSubject.name.$dirty) return errors
            !this.$v.newProcessSubject.name.required && errors.push('Nazwa folderu jest wymagana.')

            return errors
        },
        processSubjectData() {
            let processSubjectData = this.newProcessSubject

            if (this.parentFolderId) {
                processSubjectData.parentSubjectId = this.parentFolderId
            } else {
                processSubjectData.parentSubjectId = null
            }
            processSubjectData.parentFolderName = this.parentFolderName

            return processSubjectData
        }
    },
    methods: {
        saveProcessSubject() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.$emit('on-save')
                this.onClose()
            }
        },
        onClose() {
            setTimeout(() => {
                this.$v.$reset()
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>
